import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from './../../shared/shared.module';
import { AddLoadingSpaceComponent } from './add-loading-space.component';
import { LoadingSpaceAxleLoadsComponent } from './components/loading-space-axle-loads/loading-space-axle-loads.component';
import { LoadingSpaceDimensionsComponent } from './components/loading-space-dimensions/loading-space-dimensions.component';
import { LoadingSpaceListElementComponent } from './components/loading-space-list-element/loading-space-list-element.component';
import { LoadingSpacePreviewComponent } from './components/loading-space-preview/loading-space-preview.component';
import { LoadingSpaceWheelArchesComponent } from './components/loading-space-wheel-arches/loading-space-wheel-arches.component';
import { LoadingSpaceSetComponent } from './components/loading-space-set/loading-space-set.component';
import { LoadingSpaceCoolerComponent } from './components/loading-space-cooler/loading-space-cooler.component';
import { LoadingSpaceVarioFloorComponent } from './components/loading-space-vario-floor/loading-space-vario-floor.component';
import { LoadingSpaceGravityCenterComponent } from './components/loading-space-gravity-center/loading-space-gravity-center.component';
import { LoadingSpaceDoorSizeComponent } from './components/loading-space-door-size/loading-space-door-size.component';
import { LoadingSpaceAirDimensionsComponent } from './components/loading-space-air-dimensions/loading-space-air-dimensions.component';
import { AirContainerPreviewComponent } from './components/air-container-preview/air-container-preview.component';
import { LoadingSpacePalletDimensionsComponent } from './components/loading-space-pallet-dimensions/loading-space-pallet-dimensions.component';
import { LoadingSpacePalletStackingComponent } from './components/loading-space-pallet-stacking/loading-space-pallet-stacking.component';
import { LoadingSpacePalletVehicleLoadingComponent } from './components/loading-space-pallet-vehicle-loading/loading-space-pallet-vehicle-loading.component';

@NgModule({
  declarations: [
    AddLoadingSpaceComponent,
    LoadingSpaceListElementComponent,
    LoadingSpaceDimensionsComponent,
    LoadingSpaceAxleLoadsComponent,
    LoadingSpacePreviewComponent,
    LoadingSpaceSetComponent,
    LoadingSpaceWheelArchesComponent,
    LoadingSpaceCoolerComponent,
    LoadingSpaceVarioFloorComponent,
    LoadingSpaceGravityCenterComponent,
    LoadingSpaceDoorSizeComponent,
    LoadingSpaceAirDimensionsComponent,
    AirContainerPreviewComponent,
    LoadingSpacePalletDimensionsComponent,
    LoadingSpacePalletStackingComponent,
    LoadingSpacePalletVehicleLoadingComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [
    AddLoadingSpaceComponent,
    LoadingSpaceListElementComponent,
    LoadingSpaceDimensionsComponent,
    LoadingSpaceAxleLoadsComponent,
    LoadingSpacePreviewComponent,
    LoadingSpaceSetComponent,
    LoadingSpaceWheelArchesComponent,
    LoadingSpaceCoolerComponent,
    LoadingSpaceVarioFloorComponent,
    LoadingSpaceGravityCenterComponent,
    LoadingSpaceDoorSizeComponent,
    LoadingSpaceAirDimensionsComponent,
    AirContainerPreviewComponent,
    LoadingSpacePalletDimensionsComponent,
    LoadingSpacePalletStackingComponent,
    LoadingSpacePalletVehicleLoadingComponent,
  ],
})
export class AddLoadingSpaceModule {}
